//*Package imports
import React, { useEffect } from "react";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { setInitialized } from "./store/features/app/appSlice";
//*UI component imports
import Login from "./components/pages/login/Login";
import NotFoundPage from "./components/pages/404/NotFound";
import ResetPassword from "./components/pages/resetPassword/ResetPassword";
import Settings from "./components/pages/settings/Settings";
import Resources from "./components/pages/resources/Resources";
import Chat from "./components/pages/chat/Chat";
import Patients, {
  patientDetailLoader,
} from "./components/pages/patient/Patients";
import SelectClinic from "./components/pages/dashboard/SelectClinic";
import DashboardHome from "./components/pages/dashboard/DashboardHome";
import PatientDashboard from "./components/pages/patient/PatientDashboard";
import Profile from "./components/pages/settings/Profile";
import ChangePassword from "./components/pages/settings/ChangePassword";
import DefaultAssessment from "./components/pages/settings/DefaultAssessment";
import QuickHelp from "./components/pages/resources/QuickHelp";
import HelpfulMaterials from "./components/pages/resources/HelpfulMaterials";
import FAQ from "./components/pages/resources/FAQ";
import AgoraRTM from "agora-rtm-sdk";
import { RtmRole } from "agora-access-token";
import { getPrivilegeExipryRTM } from "./util/helpers";
import { getToken } from "./components/pages/chat/AgoraMethods";
import NewPassword from "./components/pages/resetPassword/NewPassword";
import CareGiver from "./components/pages/caregiver/caregiver";
import LandingPage from "./components/pages/caregiver/LandingPage";
import VideoCallComponent from "./components/pages/telehealth/VideoCallComponent";
import BillingDashboard from "./components/pages/billing/BillingDashboard";
import ACOExecutiveDashboard from "./components/pages/aco/ACOExecutiveDashboard";
import CareMembers from "./components/pages/aco/CareMembers";
import BillingReport from "./components/pages/billing/BillingReport/BillingReport";
import Home from "./components/pages/ops/Home";
import AllClinics from "./components/pages/ops/AllClinics/AllClinics";
import SingleClinic from "./components/pages/ops/SingleClinic";
import ClassEnrollments from "./components/pages/ops/ClassEnollmentsTable/ClassEnrollments";
import Clinicians from "./components/pages/ops/CliniciansTable/Clinicians";
import PatientsList from "./components/pages/ops/PatientsTable/PatientsList";
import OverdueInvoices from "./components/pages/ops/OverdueInvoices/OverdueInvoices";
import PatientMeasure from "./components/pages/aco/PatientMeasure";
import ProfilePDF from "./components/pages/patient/PatientComponents/ProfilePDF";
import Utilization from "./components/pages/ops/Utilization/Utilizations";
import Revenue from "./components/pages/ops/Revenue/Revenue";
import moment from "moment-timezone";
import Applink from "./components/pages/applink/Applink";

moment.tz.setDefault();
// moment.tz.setDefault("America/Denver"); //MST
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <NotFoundPage />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "reset",
    element: <ResetPassword />,
  },
  {
    path: "resetPassword/confirm",
    element: <NewPassword />,
  },
  {
    path: "caregiver",
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "assessments",
        element: <CareGiver />,
      },
    ],
  },
  {
    path: "caregiver-landing", // Add this path
    element: <Navigate to="/caregiver/" />, // Redirect to "caregiver"
  },
  {
    path: "telehealth",
    children: [
      {
        index: true,
        element: <VideoCallComponent />,
      },
    ],
  },
  {
    path: "billing",
    children: [
      {
        index: true,
        element: <BillingDashboard />,
      },
      {
        path: "reports/:patientid/:date",
        element: <BillingReport />,
      },
    ],
  },
  {
    path: "aco",
    children: [
      {
        path: "home",
        element: <ACOExecutiveDashboard />,
      },
      {
        index: true,
        element: <ACOExecutiveDashboard />,
      },
      {
        path: "members",
        element: <CareMembers />,
      },
      {
        path: "patient/:type",
        element: <PatientMeasure />,
      },
    ],
  },
  {
    path: "ops",
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "clinics/:type",
        element: <AllClinics />,
      },
      {
        path: "clinic/:clinicID",
        element: <SingleClinic />,
      },
      {
        path: "class-enrollments",
        element: <ClassEnrollments />,
      },
      {
        path: "reports/clinicians",
        element: <Clinicians />,
      },
      {
        path: "reports/patients/",
        element: <PatientsList />,
      },
      {
        path: "reports/utilization/",
        element: <Utilization />,
      },
      {
        path: "reports/revenue/",
        element: <Revenue />,
      },
      {
        path: "reports/overdue-invoices/",
        element: <OverdueInvoices />,
      },
    ],
  },
  {
    path: "dashboard",
    children: [
      {
        index: true,
        element: <SelectClinic />,
      },

      {
        path: "select-clinic",
        element: <SelectClinic />,
      },
      {
        path: "home",
        element: <DashboardHome />,
      },
    ],
  },
  {
    path: "settings",
    element: <Settings />,
    children: [
      {
        index: true,
        element: <Profile />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "",
        element: <ChangePassword />,
      },
      {
        path: "change-password",
        element: <ChangePassword />,
      },
      {
        path: "default-assessment",
        element: <DefaultAssessment />,
      },
      {
        path: "quick-help",
        element: <QuickHelp />,
      },
      {
        path: "help",
        element: <HelpfulMaterials />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
    ],
  },
  {
    path: "resources",
    element: <Resources />,
    children: [
      {
        index: true,
        element: <FAQ />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
      {
        path: "quick-help",
        element: <QuickHelp />,
      },
      {
        path: "helpful-materials",
        element: <HelpfulMaterials />,
      },
    ],
  },
  {
    path: "patients",
    element: <Patients />,
    children: [
      {
        path: "all",
        element: <Patients />,
      },
      {
        path: ":patientid",
        loader: patientDetailLoader,
        element: <PatientDashboard />,
      },
    ],
  },
  {
    path: "chat",
    element: <Chat />,
  },
  {
    path:"appstorelink",
    element: <Applink />,
    action: () => {
     // const userAgent = window.navigator.userAgent.toLowerCase();
     const userAgent = "iphone"
     console.log("userAgent: " , userAgent)
      if (userAgent.includes("android")) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.adolrose";
      } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        window.location.href = "https://apps.apple.com/us/app/rose-youth/id1596079012";
      } else {
        // Handle other platforms or fallback behavior
      }
    },
  },
]);

function App() {
  //*Chat Initialization stuff
  const client = AgoraRTM.createInstance(process.env.REACT_APP_AGORA_ID);
  const { isInitialized, user } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  useEffect(() => {
    const connect = async (uid) => {
      const role = RtmRole.Rtm_User;
      const privilegeExpriyTime = getPrivilegeExipryRTM();

      const token = getToken(
        process.env.REACT_APP_AGORA_ID,
        process.env.REACT_APP_AGORA_CERTIFICATE,
        uid,
        role,
        privilegeExpriyTime
      );
      await client
        .login({ uid, token: token })
        .then(() => {
          window.agora = client;
        })
        .catch((e) => {
          console.log("Agora Login error in App.js", e);
        });
    };

    if (user?.role.includes("CLINIC")) {
      //* Connecting as 3 separate users to mitigate dual-login issue.
      //* Mobile app compensates by sending the same message to all these 3 users at the same time as RTM!
      //* Only saves in the DB onces tho.
      const uid = user?.id.toString();
      if (window.location.pathname.includes("patients")) {
        connect(uid + "patients");
      } else if (window.location.pathname.includes("chat")) {
        connect(uid + "chat");
      } else {
        connect(uid);
      }
    }
    return () => {
      if (user?.role.includes("CLINIC")) {
        const disconnect = async () => {
          https: await client.logout();
        };
        try {
          disconnect();
        } catch (e) {
          console.log("LOGOUT ERROR");
        }
      }
    };
  }, [user]);
// console.log("Version: checkpoint - 28-11-2024");
  useEffect(() => {
    if (!isInitialized) {
      dispatch(setInitialized());
    }
  }, [isInitialized]);
  return <RouterProvider router={router} />;
}

export default App;
